/**
 * app.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

// Needed for redux-saga es6 generator support
// import '@babel/polyfill';

// Import all the third party stuff
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

// Import root app
import routes from './containers/App/App';

// Import Language & Theme Providers
import ThemeProvider from 'containers/providers/ThemeProvider/ThemeProvider';

// Load the favicon and the .htaccess file

import { loadState, saveState } from 'utils/localStorage';
// import { store } from './store';
import setupStore from './configureStore';
const initialState = loadState();
const store = setupStore(initialState);

import LanguageProvider from 'containers/providers/LanguageProvider/LanguageProvider';
import { appLocales } from './i18n';
import PrivacyPolicyModal from 'components/PrivacyPolicyModal';
import GlobalStyle from 'global-styles';

const root = ReactDOM.createRoot(document.getElementById('app'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            {/* <BrowserRouter> */}
            <LanguageProvider localesData={appLocales}>
                <ThemeProvider>
                    <>
                        <RouterProvider router={routes} />
                        <PrivacyPolicyModal />
                        <GlobalStyle />
                    </>
                </ThemeProvider>
            </LanguageProvider>
            {/* </BrowserRouter> */}
        </Provider>
    </React.StrictMode>,
);

// Persist some of the state in the local storage
store.subscribe(() => {
    const { session } = store.getState();
    saveState({ session });
});

// render(appLocales);
